import { AbilityBuilder, createMongoAbility } from "@casl/ability";
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
  if (user) {
    can("readAcoes", "TicketSgi");
    if (user.temPermissao(["admin_sgi"])) can("manage", "TicketSgi");

    if (user.temPermissao(["sgi"]))
      can(["read", "aceitaInteracao", "edit"], "TicketSgi");

    if (user.temPermissao(["sgi_leitura"])) can("read", "TicketSgi");

    can(["delete","Interagir"], "TicketInteracao", {
      "responsavel.mail": { $eq: user.email },
    });
    can(["Interagir"], "TicketInteracao", {
      "responsavelRegistro.mail": { $eq: user.email },
    });
  }
  return build();
}
